import { gql } from 'urql';

const MoveMoneyOptionsQuery = gql`
  query QueryMoveMoneyOptions {
    moveMoneyOptions {
      options {
        id
        title
        description
        availabilityHtml
        articleLink {
          copy
          article {
            ... on ZendeskArticle {
              id
              title
              articleId
            }
          }
        }
      }
    }
  }
`;
export default MoveMoneyOptionsQuery;
